module.exports = __webpack_public_path__ + "img/柚果.9e3791a8.jpg";